import React from "react";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import AppColor from "utilities/AppColor";

const styles = makeStyles(() => ({
  container: {
    padding: '0.5rem 0',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    marginLeft: '1rem',
    // pointerEvents: 'none',
    cursor: 'pointer',
    '&.active': {
      background: 'rgba(91, 210, 255, 0.5)',
      color: '#24616D',
      borderRadius: '0.25rem'
    },
    '&.checked': {
      cursor: 'pointer',
      pointerEvents: 'unset'
    }
  },
  label: {
    flex: '1 0 0px',
    marginLeft: '1.5rem',
    fontWeight: 700,
  },
  icon: {
    color: AppColor.pink,
    fontSize: '1.4rem',
    position: 'absolute',
    left: -10,
    wordBreak: 'break-word',
    '&.checked': {
      color: AppColor.mainColor
    },
    '&.invalid': {
      color: AppColor.pink
    }
  }
}));

const ProgressStep = (props) => {
  const {
    checked,
    active,
    invalid,
    label,
    onClick
  } = props;
  const { t } = useTranslation();
  const classes = styles();

  return (
    <div className={`${classes.container} ${active && 'active'} ${checked && 'checked'}`} onClick={onClick}>
      {
        invalid
          ? (
            <i className={`${classes.icon} fas fa-exclamation-circle invalid`}></i>
          )
          : checked
            ? (<i className={`${classes.icon} fas fa-check-circle checked`}></i>)
            : (<i className={`${classes.icon} fas fa-exclamation-circle`}></i>)
      }
      <div className={classes.label}>
        {t(label)}
      </div>
    </div >
  );
}

ProgressStep.propTypes = {
  checked: PropTypes.bool,
  active: PropTypes.bool,
  invalid: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func
};

export default ProgressStep;
